import * as React from "react"
import dummy from "../../images/dummy.png"
import Layout from "../../components/layout/layout";

import bedsheet from "../../images/products/hospitality/bedsheet.jpg"
import pillow from "../../images/products/hospitality/pillow.jpg"

const HospitalityPage = () => {
    return (
        <Layout pageName={"Hospitality"}>
            <div className="container justify-content-center align-items-center">
                <p
                    data-sal="fade"
                    data-sal-delay="100"
                    data-sal-easing="easeInExpo"
                    className="pb-10 lead fs-23 my-3"
                >
                    <i className="text-orange bi bi-arrow-right-short"/>
                    Texbond have customized the products for Hospitality Industry.
                </p>
                <div className="pb-15 grid grid-view text-center">
                    <div className="row gx-md-8 gy-10 gy-md-13">
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={bedsheet} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Bed Sheet
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Medium 80” x 31” &amp; Large 80” x 56”
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                White
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                60 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Non – absorbent &amp;
                                                Breathable, Natural Latex Free, Non-Sterile, Economical and cheaper than the laundry,
                                                Detergent and ironing costs, Light Weight provides comfort, Non toxic, no skin irritation,
                                                no allergy.
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={pillow} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Pillow Covers
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                30” x 18.5”
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                White
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                40 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Non – absorbent &amp;
                                                Breathable, Natural Latex Free, Non-Sterile, Economical and cheaper than the laundry,
                                                Detergent and ironing costs, Light Weight provides comfort, Non toxic, no skin irritation,
                                                no allergy.
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default HospitalityPage